import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private router: Router) { }

  login(role: string): void {
    localStorage.setItem('authToken', 'sample-token'); // Mock token
    localStorage.setItem('userRole', role);
    this.redirectToDashboard();
  }

  isAuthenticated(): boolean {
    return !!localStorage.getItem('authToken');
  }

  getRole(): string | null {
    return localStorage.getItem('userRole');
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['/']);
  }

  redirectToDashboard(): void {
    const role = this.getRole();
    if (role === 'POB') {
      this.router.navigate(['/pobDashboard']);
    } else if (role === 'REP') {
      this.router.navigate(['/kycDashboard']);
    } else if (role === 'POBREP') {
      this.router.navigate(['/kycRepDashboard']);
    } else {
      this.router.navigate(['/']); // Fallback to login if role is invalid
    }
  }
}
